function sliderInit(elem){
  try{
    elem.slick({
      dots: false,
      arrows: true,
      infinite: false,
      variableWidth: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }]
    });
  } catch(e) {
    setTimeout(function(){
      sliderInit($(elem));
    }, 2000);
  }
};
